import ChooseUserContainer from './ChooseUserContainer';

export default ChooseUserContainer;
